import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const PosEnvironmentCodeRoutes: Routes = [
  {
    path: "pos-environment-code",
    loadComponent: () =>
      import("./pos-environment-code/pos-environment-code.component").then(
        (m) => m.PosEnvironmentCodeComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./pos-environment-code-list/pos-environment-code-list.component").then(
            (m) => m.PosEnvironmentCodeListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./pos-environment-code-form/pos-environment-code-form.component").then(
            (m) => m.PosEnvironmentCodeFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./pos-environment-code-form/pos-environment-code-form.component").then(
            (m) => m.PosEnvironmentCodeFormComponent,
          ),
      },
    ],
  },
];
